// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../k8-opt-exec-ST-a828a81199fe/bin/redo/shopify/extension/webpack.bin.runfiles/npm_css-loader_6.7.3-dc3fc578/files/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../k8-opt-exec-ST-a828a81199fe/bin/redo/shopify/extension/webpack.bin.runfiles/npm_css-loader_6.7.3-dc3fc578/files/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._5-0 {\n  display: flex;\n}\n\n._5-1 {\n  flex-direction: row;\n}\n\n._5-2 {\n  flex-direction: column;\n}\n\n._5-3 {\n  flex-direction: row-reverse;\n}\n\n._5-4 {\n  flex-direction: column-reverse;\n}\n\n._5-5 {\n  align-items: center;\n}\n._5-6 {\n  align-items: flex-start;\n}\n._5-7 {\n  align-items: flex-end;\n}\n._5-8 {\n  align-items: stretch;\n}\n._5-9 {\n  align-items: baseline;\n}\n\n._5-a {\n  align-self: center;\n}\n._5-b {\n  align-self: flex-start;\n}\n._5-c {\n  align-self: flex-end;\n}\n._5-d {\n  align-self: stretch;\n}\n._5-e {\n  align-self: baseline;\n}\n\n._5-f {\n  justify-content: center;\n}\n._5-g {\n  justify-content: flex-start;\n}\n._5-h {\n  justify-content: flex-end;\n}\n._5-i {\n  justify-content: space-between;\n}\n._5-j {\n  justify-content: space-around;\n}\n._5-k {\n  justify-content: space-evenly;\n}\n\n._5-l {\n  flex-wrap: wrap;\n}\n\n._5-m {\n  flex-wrap: nowrap;\n}\n\n._5-n {\n  flex-wrap: wrap-reverse;\n}\n", ""]);
// Exports
export var flex = "_5-0";
export var row = "_5-1";
export var column = "_5-2";
export var rowReverse = "_5-3";
export var columnReverse = "_5-4";
export var alignCenter = "_5-5";
export var alignFlexStart = "_5-6";
export var alignFlexEnd = "_5-7";
export var alignStretch = "_5-8";
export var alignBaseline = "_5-9";
export var alignSelfCenter = "_5-a";
export var alignSelfFlexStart = "_5-b";
export var alignSelfFlexEnd = "_5-c";
export var alignSelfStretch = "_5-d";
export var alignSelfBaseline = "_5-e";
export var justifyCenter = "_5-f";
export var justifyFlexStart = "_5-g";
export var justifyFlexEnd = "_5-h";
export var justifySpaceBetween = "_5-i";
export var justifySpaceAround = "_5-j";
export var justifySpaceEvenly = "_5-k";
export var wrapWrap = "_5-l";
export var wrapNowrap = "_5-m";
export var wrapWrapReverse = "_5-n";
export default ___CSS_LOADER_EXPORT___;
